// Recovered compiled webpack factory 39619. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    AP: () => d,
    LV: () =>
      function e(t, r = {}) {
        if ("function" != typeof t) return t;
        try {
          let e = t.__sentry_wrapped__;
          if (e)
            if ("function" == typeof e) return e;
            else return t;
          if ((0, a.sp)(t)) return t;
        } catch {
          return t;
        }
        let n = function (...n) {
          try {
            let a = n.map((t) => e(t, r));
            return t.apply(this, a);
          } catch (e) {
            throw (
              c++,
              setTimeout(() => {
                c--;
              }),
              (0, o.v4)((t) => {
                (t.addEventProcessor(
                  (e) => (
                    r.mechanism && ((0, i.gO)(e, void 0, void 0), (0, i.M6)(e, r.mechanism)),
                    (e.extra = { ...e.extra, arguments: n }),
                    e
                  ),
                ),
                  (0, s.Cp)(e));
              }),
              e
            );
          }
        };
        try {
          for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
        } catch {}
        ((0, a.pO)(n, t), (0, a.my)(t, "__sentry_wrapped__", n));
        try {
          Object.getOwnPropertyDescriptor(n, "name").configurable &&
            Object.defineProperty(n, "name", { get: () => t.name });
        } catch {}
        return n;
      },
    jN: () => f,
    jf: () => u,
  });
  var n = r(49636),
    a = r(73314),
    o = r(2257),
    i = r(28385),
    s = r(27122),
    l = r(60567);
  let u = n.O,
    c = 0;
  function f() {
    return c > 0;
  }
  function d() {
    let e = (0, l.$N)(),
      { referrer: t } = u.document || {},
      { userAgent: r } = u.navigator || {};
    return { url: e, headers: { ...(t && { Referer: t }), ...(r && { "User-Agent": r }) } };
  }
}
